import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Config } from '../config';
import { User } from '../models';

@Injectable({
    providedIn: 'root'
})
export class AdministrationService {

    constructor(
        private config: Config,
        private http: HttpClient
    ) { }

    getReservationCompanies(idUser: number): Observable<any[]> {
        return this.http.get<any[]>(this.config.get('API_SERVER_URL') + `/management/user/${idUser}/reservation-companies`);
    }

    getHotParkingCompanies(idUser: number): Observable<any[]> {
        return this.http.get<any[]>(this.config.get('API_SERVER_URL') + `/management/user/${idUser}/hotparking-companies`);
    }

    setReservationCompanies(idUser: number, companiesIds: number[]) {
        return this.http.put(this.config.get('API_SERVER_URL') + `/management/user/${idUser}/reservation-companies`, companiesIds);
    }

    setHotParkingCompanies(idUser: number, companiesIds: number[]) {
        return this.http.put(this.config.get('API_SERVER_URL') + `/management/user/${idUser}/hotparking-companies`, companiesIds);
    }

    getAllUsers(active: boolean = false): Observable<Array<User>> {
        return this.http.get<Array<User>>(this.config.get('API_SERVER_URL') + `/management/users?active=${active}`);
    }

    getById(id: number): Observable<User> {
        return this.http.get<User>(this.config.get('API_SERVER_URL') + `/management/user/${id}`);
    }

    createOrUpdate(accessUser: Object): Observable<User> {
        return this.http.put<User>(this.config.get('API_SERVER_URL') + '/management/user', accessUser);
    }

    getConfigByUserId(id: number): Observable<Array<any>> {
        return this.http.get<Array<any>>(this.config.get('API_SERVER_URL') + `/management/user/${id}/permission`);
    }

    getUserRoles(id: number): Observable<Array<any>> {
        return this.http.get<Array<any>>(this.config.get('API_SERVER_URL') + `/management/user/${id}/roles`);
    }

    resetUserPassword(login: string): Observable<any> {
        return this.http.post(this.config.get('API_SERVER_URL') + '/management/resetPassword', login, { headers: { "Content-Type": "application/json" } });
    }

    setUserRoles(idUser: number, rolesIds: number[]): Observable<any> {
        return this.http.put(this.config.get('API_SERVER_URL') + `/management/user/${idUser}/roles`, rolesIds);
    }
}
